// Ensure date-only strings are treated as local dates to avoid TZ shifts
export default function parseDateForPicker(value, type) {
    if (!value) {
        if (type === "dateRange") {
            const now = new Date()
            return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 12, 0, 0, 0)
        }
        return new Date()
    }
    if (type === "dateRange") {
        if (typeof value === "string") {
            const m = value.match(/^(\d{4})-(\d{2})-(\d{2})$/)
            if (m) {
                return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]), 12, 0, 0, 0)
            }
        }
        const d = new Date(value)
        return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 12, 0, 0, 0)
    }
    return new Date(value)
}